import { ActivatedRoute } from '@angular/router';

/**
 * Pagination service
 */
export class PaginationService {

    constructor(protected activatedRoute: ActivatedRoute) {}

    /**
     * Find page number from "page" param in url
     * @returns page number 
     * @returns -1 if no param found or NaN
     */
    public findPageInUrl(): number {
        let pageNo = -1;

        const params = this.activatedRoute.snapshot.queryParams;
        if (params && params.page) {
            const pageUrlParam = params.page - 1;
            pageNo = (!pageUrlParam || pageUrlParam < 0) ? -1 : pageUrlParam;
        }

        return pageNo;
    }
}
